export const Palette = {
  colors: [
    {h: 0, s: 50, l: 65},
    {h: 10, s: 50, l: 60},
    {h: 20, s: 50, l: 55},
    {h: 30, s: 50, l: 55},
    {h: 40, s: 50, l: 50},
    {h: 50, s: 50, l: 45},
    {h: 60, s: 50, l: 45},
    {h: 70, s: 50, l: 40},
    {h: 80, s: 50, l: 40},
    {h: 90, s: 50, l: 40},
    {h: 100, s: 50, l: 40},
    {h: 110, s: 50, l: 40},
    {h: 120, s: 50, l: 40},
    {h: 130, s: 50, l: 45},
    {h: 140, s: 50, l: 45},
    {h: 150, s: 50, l: 50},
    {h: 160, s: 50, l: 50},
    {h: 170, s: 50, l: 50},
    {h: 180, s: 50, l: 50},
    {h: 190, s: 50, l: 50},
    {h: 200, s: 50, l: 55},
    {h: 210, s: 50, l: 55},
    {h: 220, s: 50, l: 60},
    {h: 230, s: 50, l: 60},
    {h: 240, s: 50, l: 60},
    {h: 250, s: 50, l: 55},
    {h: 260, s: 50, l: 50},
    {h: 270, s: 50, l: 50},
    {h: 280, s: 50, l: 50},
    {h: 290, s: 50, l: 50},
    {h: 300, s: 50, l: 50},
    {h: 310, s: 50, l: 50},
    {h: 320, s: 50, l: 50},
    {h: 330, s: 50, l: 50},
    {h: 340, s: 50, l: 55},
    {h: 350, s: 50, l: 60},
    {h: 0, s: 60, l: 65},
    {h: 10, s: 60, l: 60},
    {h: 20, s: 60, l: 55},
    {h: 30, s: 60, l: 55},
    {h: 40, s: 60, l: 50},
    {h: 50, s: 60, l: 45},
    {h: 60, s: 60, l: 45},
    {h: 70, s: 60, l: 40},
    {h: 80, s: 60, l: 40},
    {h: 90, s: 60, l: 40},
    {h: 100, s: 60, l: 40},
    {h: 110, s: 60, l: 40},
    {h: 120, s: 60, l: 40},
    {h: 130, s: 60, l: 45},
    {h: 140, s: 60, l: 45},
    {h: 150, s: 60, l: 50},
    {h: 160, s: 60, l: 50},
    {h: 170, s: 60, l: 50},
    {h: 180, s: 60, l: 50},
    {h: 190, s: 60, l: 50},
    {h: 200, s: 60, l: 55},
    {h: 210, s: 60, l: 55},
    {h: 220, s: 60, l: 60},
    {h: 230, s: 60, l: 60},
    {h: 240, s: 60, l: 60},
    {h: 250, s: 60, l: 55},
    {h: 260, s: 60, l: 50},
    {h: 270, s: 60, l: 50},
    {h: 280, s: 60, l: 50},
    {h: 290, s: 60, l: 50},
    {h: 300, s: 60, l: 50},
    {h: 310, s: 60, l: 50},
    {h: 320, s: 60, l: 50},
    {h: 330, s: 60, l: 50},
    {h: 340, s: 60, l: 55},
    {h: 350, s: 60, l: 60},
    {h: 0, s: 50, l: 65},
    {h: 10, s: 50, l: 60},
    {h: 20, s: 50, l: 55},
    {h: 30, s: 50, l: 55},
    {h: 40, s: 50, l: 50},
    {h: 50, s: 50, l: 45},
    {h: 60, s: 50, l: 45},
    {h: 70, s: 50, l: 40},
    {h: 80, s: 50, l: 40},
    {h: 90, s: 50, l: 40},
    {h: 100, s: 50, l: 40},
    {h: 110, s: 50, l: 40},
    {h: 120, s: 50, l: 40},
    {h: 130, s: 50, l: 45},
    {h: 140, s: 50, l: 45},
    {h: 150, s: 50, l: 50},
    {h: 160, s: 50, l: 50},
    {h: 170, s: 50, l: 50},
    {h: 180, s: 50, l: 50},
    {h: 190, s: 50, l: 50},
    {h: 200, s: 50, l: 55},
    {h: 210, s: 50, l: 55},
    {h: 220, s: 50, l: 60},
    {h: 230, s: 50, l: 60},
    {h: 240, s: 50, l: 60},
    {h: 250, s: 50, l: 55},
    {h: 260, s: 50, l: 50},
    {h: 270, s: 50, l: 50},
    {h: 280, s: 50, l: 50},
    {h: 290, s: 50, l: 50},
    {h: 300, s: 50, l: 50},
    {h: 310, s: 50, l: 50},
    {h: 320, s: 50, l: 50},
    {h: 330, s: 50, l: 50},
    {h: 340, s: 50, l: 55},
    {h: 350, s: 50, l: 60}],

  getColor(id): {} {
    return this.colors[this.hash(id) % this.colors.length];
  },

  getHSLA(id): string {
    const color = this.getColor(id);
    return "color: hsla(" + color.h + ", " + color.s + "%, " + color.l + "%, 1);";
  },

  hash(id): number {
    id = ((id >> 16) ^ id) * 0x45d9f3b;
    id = ((id >> 16) ^ id) * 0x45d9f3b;
    id = (id >> 16) ^ id;
    return id;
  }
};
